import { useEffect, useRef, useState } from "react";
import Input from "../Components/Input";
import axios from "axios";

export default function Triage({ cases }) {

    const [priority, setPriority] = useState("Medium");
    const [generated, setGenerated] = useState(false);
    const [scans, setScans] = useState([])

    const [audioURL, setAudioURL] = useState(null);
    const [audioBlob, setAudioBlob] = useState(null);

    const [recording, setRecording] = useState(false);
    const mediaRecorderRef = useRef(null);
    const chunksRef = useRef([])

    const startRecording = async () => {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true })


        mediaRecorderRef.current = new MediaRecorder(stream);

        chunksRef.current = [];

        mediaRecorderRef.current.ondataavailable = (e) => {
            chunksRef.current.push(e.data);

        };
        mediaRecorderRef.current.start();
        setRecording(true)
    }

    const stopRecording = () => {
        const recorder = mediaRecorderRef.current;

        recorder.onstop = async () => {
            const blob = new Blob(chunksRef.current, { type: "audio/webm" })

            const url = URL.createObjectURL(blob);

            setAudioBlob(blob)
            setAudioURL(url)

        }
        recorder.stop();
        console.log(audioURL)
        setRecording(false)

    }

    const sendAudio = async () =>{
        const formData = new FormData();
        formData.append("file", audioBlob, "audio.webm");
        document.getElementById('transcribe-btn').innerText = "Transcribing..."
        document.getElementById('start-record-btn').disabled = true;

        const res = await axios.post(`${process.env.REACT_APP_API_URL}/ai/transcribe`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
        document.getElementById('transcribe-btn').innerText = "Transcribe"        
        document.getElementById('start-record-btn').disabled = false;
        document.getElementById('condition-report').value = res.data.text;

    }




    function generateId(modality) {
        const num = Math.floor(Math.random() * 100000);
        return `${modality}-${num}`;
    }
    async function registerCase(caseData) {
        axios.post(`${process.env.REACT_APP_API_URL}/cases`,
            {
                patient_id: caseData.patient_id,
                first_name: caseData.first_name,
                last_name: caseData.last_name,
                modality: caseData.modality,
                body: caseData.body,
                age: caseData.age,
                priority: caseData.priority,
                status: caseData.status,
                phone_number: caseData.phone_number,
                chief_complaint: caseData.chief_complaint,
                duration: caseData.duration,
                summary: caseData.summary
            }
        ).then((res) => {
            console.log(res.data)
            alert("Case registered successfully!");
            window.location.reload();
        }).catch(err => {
            console.log(err.message)
            alert("Error occurred while registering")
            window.location.reload();
        })
    }
    function handleSubmit(e) {
        e.preventDefault();
        const formdata = new FormData(e.target);
        formdata.append("patient_id", generateId(formdata.get("modality")));
        formdata.append("status", "AWAITING_PAYMENT");
        const data = Object.fromEntries(formdata.entries());
        registerCase(data);
        e.target.reset();
    }
    function generateReport(message) {
        const button = document.getElementById('generate-btn-2');
        button.disabled = true;
        button.innerText = "Generating...";
        axios.post(`${process.env.REACT_APP_API_URL}/ai/intake`, {
            message
        }).then(res => {
            const { parsed } = res.data;
            document.querySelector('input[name="chief_complaint"]').value = parsed.chief_complaint;
            document.querySelector('input[name="duration"]').value = parsed.duration;
            document.querySelector('textarea[name="summary"]').value = parsed.summary;
            setGenerated(true);
            button.disabled = false;
            button.innerText = "✨ Generate";
        }).catch(err => {
            console.log(err.message)
            alert("Error Generating Summary: API key limit reached")
            button.disabled = false;
            button.innerText = "✨ Generate";
        })

    }
    useEffect(() => {
        document.querySelector(".triage-link").classList.toggle('on', true)
        axios.get(`${process.env.REACT_APP_API_URL}/scan_types`).then(res => {
            setScans(res.data)
        })




    }, [])

    return (

        <div className="triage-container">
            <section>
                <h2 >New Patient Case</h2>
                <form className="input-group" onSubmit={handleSubmit}>
                    <input
                        placeholder='First Name'
                        className="custom-input"
                        required
                        name="first_name"

                    />
                    <input
                        placeholder='Last Name'
                        className="custom-input"
                        required
                        name="last_name"
                    />
                    <input
                        placeholder="Phone Number"
                        className="custom-input"
                        required
                        name="phone_number"
                    />
                    <fieldset className="ai-section">
                        <legend>AI Clinical History Generator</legend>
                        <textarea
                            placeholder='Describe patient condition (e.g. headache for 2 weeks, worse in morning...)'
                            className="custom-input"
                            name="clinical_history"
                            id="condition-report"
                            rows={4}
                        />
                        {audioURL && (
                            <><audio controls src={audioURL}></audio>
                                <button type="button" onClick={sendAudio} id="transcribe-btn">Transcribe</button></>
                        )}
                        <section className="btn-section">

                            {
                                recording ?
                                    <button type="button" className="btn-stop" id="stop-record-btn" onClick={stopRecording}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-stop-fill" viewBox="0 0 16 16">
                                            <path d="M5 3.5h6A1.5 1.5 0 0 1 12.5 5v6a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 11V5A1.5 1.5 0 0 1 5 3.5" />
                                        </svg>
                                    </button>
                                    :
                                    <button type="button" onClick={startRecording} id="start-record-btn">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-mic" viewBox="0 0 16 16">
                                            <path d="M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5" />
                                            <path d="M10 8a2 2 0 1 1-4 0V3a2 2 0 1 1 4 0zM8 0a3 3 0 0 0-3 3v5a3 3 0 0 0 6 0V3a3 3 0 0 0-3-3" />
                                        </svg>

                                    </button>
                            }

                            <button id="generate-btn-2" type="button" onClick={() => generateReport(document.getElementById('condition-report').value)}>✨ Generate</button>
                        </section>
                    </fieldset>
                    <input
                        placeholder="Chief Complaint"
                        className="custom-input"
                        name="chief_complaint"
                        disabled={!generated}
                    />

                    <input
                        placeholder="Duration"
                        className="custom-input"
                        name="duration"
                        disabled={!generated}
                    />

                    <textarea
                        placeholder="Clinical Summary"
                        className="custom-input"
                        name="summary"
                        disabled={!generated}
                        rows={4}

                    />
                    <select className="custom-input" defaultValue={0} name="modality">
                        <option value={0}>Please select the scan type</option>
                        {scans.length > 0 &&
                            (
                                scans.map((e, i) => {
                                    return <option key={i} value={e}>{e}</option>
                                })
                            )
                        }

                    </select>
                    <input
                        placeholder='Age'
                        className="custom-input"
                        required
                        name="age"
                    />
                    <input
                        placeholder='Body Part'
                        className="custom-input"
                        required
                        name="body"
                    />
                    <select className="custom-input" defaultValue={priority} name="priority">
                        <option value="Low">Low</option>
                        <option value="Medium">Medium</option>
                        <option value="High">High</option>
                    </select>
                    <button type="submit">Create Case</button>

                </form>
            </section>
            <div className="cases-container">
                <h2 className="font-bold">Cases</h2>
                <section className="card-container">
                    {cases.map(c => (
                        <div className="card" key={c.patient_id} >
                            <p>Patient ID: <span>{c.patient_id}</span></p>
                            <p>Name: <span>{c.first_name} {c.last_name}</span></p>
                            <p>Modality: <span>{c.modality} {c.body}</span></p>
                            <p>Age: <span>{c.age}</span></p>
                            <p>Status: <span>{c.status}</span></p>
                            <p>Priority: <span className={c.priority ? `status ${c.priority.toLowerCase()}` : ''}>{c.priority}</span></p>
                        </div>
                    ))}
                </section>
            </div>
        </div>

    );
}
